var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDrug(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15.0294,
    y: 0.605957,
    width: 48,
    height: 48,
    rx: 10,
    transform: "rotate(15 15.0294 0.605957)",
    fill: "#36BFFA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_43161_790)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 14,
    width: 48,
    height: 48,
    rx: 10,
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 14.5,
    width: 47,
    height: 47,
    rx: 9.5,
    stroke: "white",
    strokeOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 48C29.5228 48 34 43.5228 34 38C34 32.4772 29.5228 28 24 28C18.4772 28 14 32.4772 14 38C14 43.5228 18.4772 48 24 48Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8333 33.3C25.8333 33.02 25.8333 32.88 25.7788 32.773C25.7309 32.6789 25.6544 32.6024 25.5603 32.5545C25.4534 32.5 25.3134 32.5 25.0333 32.5H22.9667C22.6866 32.5 22.5466 32.5 22.4397 32.5545C22.3456 32.6024 22.2691 32.6789 22.2212 32.773C22.1667 32.88 22.1667 33.02 22.1667 33.3V35.3667C22.1667 35.6467 22.1667 35.7867 22.1122 35.8937C22.0642 35.9877 21.9877 36.0642 21.8937 36.1122C21.7867 36.1667 21.6467 36.1667 21.3667 36.1667H19.3C19.02 36.1667 18.88 36.1667 18.773 36.2212C18.6789 36.2691 18.6024 36.3456 18.5545 36.4397C18.5 36.5466 18.5 36.6866 18.5 36.9667V39.0333C18.5 39.3134 18.5 39.4534 18.5545 39.5603C18.6024 39.6544 18.6789 39.7309 18.773 39.7788C18.88 39.8333 19.02 39.8333 19.3 39.8333H21.3667C21.6467 39.8333 21.7867 39.8333 21.8937 39.8878C21.9877 39.9358 22.0642 40.0123 22.1122 40.1063C22.1667 40.2133 22.1667 40.3533 22.1667 40.6333V42.7C22.1667 42.98 22.1667 43.12 22.2212 43.227C22.2691 43.3211 22.3456 43.3976 22.4397 43.4455C22.5466 43.5 22.6866 43.5 22.9667 43.5H25.0333C25.3134 43.5 25.4534 43.5 25.5603 43.4455C25.6544 43.3976 25.7309 43.3211 25.7788 43.227C25.8333 43.12 25.8333 42.98 25.8333 42.7V40.6333C25.8333 40.3533 25.8333 40.2133 25.8878 40.1063C25.9358 40.0123 26.0123 39.9358 26.1063 39.8878C26.2133 39.8333 26.3533 39.8333 26.6333 39.8333H28.7C28.98 39.8333 29.12 39.8333 29.227 39.7788C29.3211 39.7309 29.3976 39.6544 29.4455 39.5603C29.5 39.4534 29.5 39.3134 29.5 39.0333V36.9667C29.5 36.6866 29.5 36.5466 29.4455 36.4397C29.3976 36.3456 29.3211 36.2691 29.227 36.2212C29.12 36.1667 28.98 36.1667 28.7 36.1667H26.6333C26.3533 36.1667 26.2133 36.1667 26.1063 36.1122C26.0123 36.0642 25.9358 35.9877 25.8878 35.8937C25.8333 35.7867 25.8333 35.6467 25.8333 35.3667V33.3Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_43161_790",
    x: -16,
    y: -2,
    width: 80,
    height: 80,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_43161_790"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_43161_790",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrug);
export default __webpack_public_path__ + "static/media/drug.d7c9b0bf4fa0e97ba908dfcf0f43b0fa.svg";
export { ForwardRef as ReactComponent };